import React from 'react';
import ImageCardSkeleton from '@/components/image-generator/ImageLibrary/components/ImageCardSkeleton';
import { GRID_BREAKPOINTS } from '@/config/grid-breakpoints';

const PrivateImageLibrarySkeleton: React.FC = () => {
  return (
    <div className={`grid ${GRID_BREAKPOINTS.imageCards} gap-1`}>
      {Array.from({ length: 8 }).map((_, index) => (
        <ImageCardSkeleton key={`skeleton-${index}`} index={index} />
      ))}
    </div>
  );
};

export default PrivateImageLibrarySkeleton; 